<template>
    <div>
        <v-container fluid class="pt-0 pl-0 pr-0 chat-layout" :ref="chatLayout" :style="styleClass">
            <div class="top-section pl-5 pr-5" :class="[{ 'scrolled': hasScrolled }]">
                <v-row class="top-text position-relative heading-style" no-gutters justify="center">
                    <v-col cols="1" class="ml-2 back-icon position-absolute" @click="handleBack">
                        <router-link :to="{}" class="linked">
                            <v-icon size="33">mdi-chevron-left</v-icon>
                        </router-link>
                    </v-col>

                    <v-col class="text-capitalize ml-12" v-if="isBroadcastingChannel && isChatOwner">
                        {{  $t('pages.channels.yourChannel') }}
                    </v-col>

                    <div
                    :class="[{ 'user-info': hasScrolled }]"
                    v-if="
                        !isBroadcastingChannel ||
                        (isBroadcastingChannel && !isChatOwner)
                    "
                     >
                        <v-row v-if="companion.id" justify="center" no-gutters>
                            <profile-image-disabled-story-view
                                size="100"
                                border="4"
                                :font-size="31"
                                :has-not-watched-stories="
                                    companion.hasNotWatchedStories
                                "
                                :is-exist-story="companion.isExistStory"
                                :img="companion.profileImage"
                                :username="companion.name"
                                :id="companion.id"
                                :scrolled="hasScrolled"
                                @click="
                                    !companion.isExistStory
                                        ? $router.push({
                                            name: 'otherUser.profile.viewSlug',
                                            params: { slug: companion.slug, from: $route.name, id: $route.params.id },
                                        })
                                        : ''
                                "
                            />
                        </v-row>
                        <v-row justify="center" align="center">
                            <icon-signal v-if="isBroadcastingChannel" class="mr-2" />
                            <router-link
                                :to="{
                                    name: 'otherUser.profile.viewSlug',
                                    params: { slug: companion.slug, from: $route.name, id: $route.params.id },
                                }"
                                class="text-h6 font-weight-regular"
                            >
                                {{ companion.name }}
                            </router-link>
                            <verified-icon
                                v-if="companion.verified"
                                :height="16" :width="16" class="ml-1" />
                            <holiday-mood-icon :height="18" :width="18" v-if="companion.on_holiday_mood" class="mx-2" />
                        </v-row>
                    </div>
                </v-row>

                <div
                    v-if="isBroadcastingChannel && isChatOwner"
                    class="grey--text ml-12 text-body-2 mt-4"
                >
                    {{ $t("pages.channels.description.forCreators") }}
                </div>
    
                <div v-if="isBroadcastingChannel && pinnedMessage">
                    <div class="show-pinned-chat-message">
                        <span>{{ $t("pages.channels.pinned_message") }}</span>
                        <span @click="scrollToPinnedMessage = true">
                            {{ pinnedMessageDisplay }}
                        </span>
                        <v-icon @click="messageUnpinned">mdi-close</v-icon>
                    </div> 
                </div>
            </div>

            <div class="messages-section pl-5 pr-5" v-if="companion.id">
                <message-item
                    class="mt-4"
                    v-for="(message, i) in messages"
                    :key="i"
                    :message="message"
                    :last-message="i === messages.length - 1"
                    :scroll-to-last-message="scrollToLastMessage"
                    :scroll-to-pinned-message="scrollToPinnedMessage"
                    :pinned-message="pinnedMessage"
                    @scrolled="handleScrolled"
                    @scrolled-to-pin="scrolledToPin"
                    @reload-chat="handleReloadChat"
                    :is-broadcast-chat="isBroadcastingChannel"
                    :is-broadcast-owner="isChatOwner"
                    @message-pinned="MessagePinned"
                    :prize-sent="opening || null"
                    :prize-recevied="ownOpening || null"
                    @boxReceviedDialog="boxReceviedDialog"
                    @sent-prize-given="handlePrizeGiven"
                />
                <typing-message
                    class="mt-4"
                    :sender-img="companion.profileImage"
                    :is-typing="isTyping"
                />
            </div>
        </v-container>
        <div
            v-touch="{ up: () => openTipMenu() }"
            @touchmove.stop.prevent
            class="bottom-control"
        >
            <div class="recording-deleted" v-if="isRecordingDeleted">
        		<img :src="require('@/assets/delete_recording.gif')" alt="Loading..." />
        	</div>

            <button v-if="!isBroadcastingChannel || (isBroadcastingChannel && !isChatOwner)">
                <app-icon
                    icon="dollar"
                    size="24"
                    color="rgba(255,255,255,0.4)"
                    @click="openTipMenu"
                />
            </button>

            <div style="width: 100%">
                <text-field
                    :placeholder="$t('dialogs.your_message')"
                    class="pa-1"
                    dense
                    style="border-radius: 60px"
                    v-model="messageModel"
                    @keyup.enter="sendMessageMethod"
                    @keydown="handleTypingMessage"
                />
            </div>

            <template v-if="!isBroadcastingChannel || (isBroadcastingChannel && isChatOwner)">
                <button v-if="messageModel.length === 0" class="mr-2">
                    <app-icon
                        @click="handleClickPhoto"
                        icon="photo"
                        size="18"
                        color="rgba(255,255,255,0.4)"
                    />
                </button>

                <!-- TODO: Fix microphone-->
                <audio-recorder
                    class="mr-5"
                    v-if="messageModel.length === 0"
                    @startRecordingAudio="startRecordingAudio"
                    @stopRecordingAudio="stopRecordingAudio"
                    @cancelRecordingAudio="cancelRecordingAudio"
                />
            </template>

            <gradient-button
                v-if="messageModel.length !== 0"
                fab
                class="ma-0 pa-0"
                :has-max-height="false"
                width="40"
                height="40"
                :loading="isLoading"
                @click="sendMessageMethod"
            >
                <send-button-icon :height="30" :width="30" />
            </gradient-button>
        </div>
        <tip-menu-dialog
            @close="closeTipMenu"
            v-if="isShowTip"
            :target-verified="verified"
            :target-username="companion.name"
            @save="sendMessageTipMethod"
            :loading="$store.getters.loadingBtn(['setting', 'sendBtnMsg'])"
        />
        <insufficient-funds-dialog
            v-if="insufficientFundsError"
            @close="handleCloseInsufficientFundsError"
        />
        <direct-message-dialog
            v-if="showDirectMessageDialog"
            :subscribe_price="subscribePrice"
            :direct_price="directPrice"
            :paid_options="paidOptions"
            @subscribe="handleSubscribe"
            @direct-message="handleDirectMessage"
            @close="handleCloseDirectMessageDialog"
        />
        <received-box-prize-dialog 
            v-if="showReceivedPrizeDialog"
            @confirmPriceGiven="confirmPriceGiven"
            @priceNotGiven="priceNotGiven"
            @close="showReceivedPrizeDialog = false"
        />
        <reportMessageDialog
            v-if="showPopup"
            @close="showPopup = false"
            @report="reportPrizeNotGiven"
        />
        <transition-group
            appear
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            duration="200"
        >
            <record-screen
                v-if="step === 0"
                key="screen"
                :is-front-camera="isFrontCamera"
                @change-camera="isFrontCamera = $event"
            />
            <view-result
                v-if="step === 1"
                key="result"
                @close="handleCloseResult()"
            />
            <before-posting-chat v-if="step === 2" key="posting" :is-broadcast-chat="isBroadcastingChannel ? true : false" />
        </transition-group>

    </div>
</template>

<script>
const TYPE_STORY = 'story';
const TYPE_AUDIO = 'audio';

import ProfileImage from "@/components/app/profile/ProfileImage";
import MessageItem from "@/components/app/chat/MessageItem";
import TypingMessage from "@/components/app/chat/TypingMessage";
import TextField from "@/components/app/form/TextField";
import GradientButton from "@/components/app/button/GradientButton";
import SwipeTipMenu from "@/components/app/profile/SwipeTipMenu";
import InsufficientFundsDialog from "@/components/app/dialogs/InsufficientFundsDialog";
import RecordScreen from "@/views/app/postingView/RecordScreen";
import ViewResult from "@/views/app/postingView/ViewResultScreen";
import BeforePostingChat from "@/views/app/postingView/BeforePostingChat";
import DirectMessageDialog from "@/components/app/dialogs/DirectMessageDialog";
import TipMenuDialog from "@/components/app/dialogs/TipMenuDialog";
import ReceivedBoxPrizeDialog from "@/components/app/dialogs/ReceivedBoxPrizeDialog";
import reportMessageDialog from "@/components/app/dialogs/ReportMessageDialog";

import { mapActions, mapMutations, mapState } from "vuex";

import { ERROR_KEYS, INSUFFICIENT_FUNDS_ERROR } from "@/configs/constants";
import { requestCore } from "@/core";
import ProfileImageDisabledStoryView from "@/components/app/profile/ProfileImageDisabledStoryView.vue";
import IconSignal from "@/assets/images/icons/signal.svg?inline";
import VerifiedIcon from "@/components/app/common/VerifiedIcon";
import SendButtonIcon from "@/components/app/common/SendButtonIcon";
import AudioRecorder from "@/components/app/common/AudioRecorder";
import HolidayMoodIcon from "@/components/app/icons/HolidayMoodIcon";
import MysteryBoxBadgeIcon from "@/assets/images/icons/gifted-subscription.svg?inline"

export default {
    name: "Chat",
    data: () => ({
        storyExist: true,
        userImg:
            "https://i.pinimg.com/originals/97/e4/2a/97e42a82fc7911961d3ca55f54d1372c.jpg",
        messages: [],
        messageModel: "",
        isBroadcastingChannel: null,
        isChatOwner: null,
        isShowTip: false,
        interlocutorId: null,
        insufficientFundsError: false,
        chatChannel: false,
        isTyping: false,
        typingTimer: false,
        scrollToLastMessage: false,
        showDirectMessageDialog: false,
        companion: false,
        paidOptions: [],
        isFrontCamera: false,
        isAudioRecording: false,
        mediaRecorder: null,
        audioChunks: [],
        isRecordingDeleted: false,
        chatId: null,
        pinnedMessage: null,
        scrollToPinnedMessage: false,
        isLoading: false,
        hasScrolled: false,
        showReceivedPrizeDialog: false,
        opening: '',
        ownOpening: '',
        showPopup:false,
    }),
    watch: {
        isTyping(value) {
            if (value === true) {
                this.scrollToLastMessage = true;
            }
        },
    },
    components: {
        InsufficientFundsDialog,
        SwipeTipMenu,
        GradientButton,
        TextField,
        MessageItem,
        ProfileImage,
        ProfileImageDisabledStoryView,
        TypingMessage,
        DirectMessageDialog,
        RecordScreen,
        ViewResult,
        BeforePostingChat,
        IconSignal,
        VerifiedIcon,
        TipMenuDialog,
        SendButtonIcon,
        AudioRecorder,
        HolidayMoodIcon,
        ReceivedBoxPrizeDialog,
        reportMessageDialog,
        MysteryBoxBadgeIcon
    },
    props: {
        companionId: { type: Number },
        styleClass: { type: Object, default: null },
		chatLayout: {type: String, default: null }
    },
    methods: {
        ...mapMutations(["showSnackBar", "setStep"]),
        async sendMessageMethod() {
            try {
                const message = (this.messageModel || "").trim();
                if (!message) {
                    this.messageModel = "";
                    return;
                }
                this.isLoading = true;
                if (this.isBroadcastingChannel) {
                    await axios
                        .post(
                            `/api/messages/send/channel/${this.$route.params.chat_id}`,
                            {
                                message,
                            }
                        )
                        .then((response) => {
                            if (typeof response.data !== "undefined") {
                                this.setMessages(response.data.data);
                                this.messageModel = "";

                                if (!this.chatChannel) {
                                    this.setChatChannel();
                                }
                                this.toLastMessage();
                                this.isLoading = false;

                                const broadcastMessageInfo = {
                                    message_type: 'Text',
                                    channel: 'Broadcast',
                                    ownBroadcast: this.isChatOwner ? true : false,
                                };
                                this.$mixpanel.click('Send Text', 'Chat Screen', {
                                    message_info: broadcastMessageInfo
                                });
                            }
                        })
                        .catch(({ response }) => {
                            this.showSnackBar(
                                response.data.err_msg || response.data.message
                            );
                            this.isLoading = false;
                        });
                    return;
                }

                await this.checkPermissionToSendMessages();

                await this.sendMessage({
                    user_id: this.interlocutorId,
                    message,
                })
                    .then((res) => {
                        if (typeof res.data !== "undefined") {
                            this.setMessages(res.data);
                            this.messageModel = "";

                            if (!this.chatChannel) {
                                this.setChatChannel();
                            }
                            this.toLastMessage();
                            this.isLoading = false;

                            const chatMessageInfo = {
                                message_type: 'Text',
                                channel: 'Direct Message',
                                to: this.companion.name
                            };
                            this.$mixpanel.click('Send Text', 'Chat Screen', {
                                message_info: chatMessageInfo
                            });
                        }
                    })
                    .catch(({ response }) => {
                        const { data, status } = response;
                        if (status === 400) {
                            if (response.data.err_key === "should_pay_option") {
                                this.showDirectMessageDialog = true;
                                this.paidOptions = Array.isArray(
                                    data.err_paid_options
                                )
                                    ? data.err_paid_options
                                    : [];
                                return;
                            }
                            if (response.data.err_key === "cannot_send_msg") {
                                this.showSnackBar(response.data.err_msg);
                                return;
                            }
                        }
                        this.showSnackBar(
                            this.$t("messages.something_went_wrong")
                        );
                        this.isLoading = false;
                    });
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        async checkPermissionToSendMessages() {
            try {
                await requestCore
                    .POST(
                        "messages/check-permission-to-send",
                        { user_id: this.interlocutorId },
                        "/api/messages/check-permission-to-send"
                    )
                    .catch(({ response }) => {
                        const { data, status } = response;
                        if (status === 400) {
                            if (response.data.err_key === "should_pay_option") {
                                this.showDirectMessageDialog = true;
                                this.paidOptions = Array.isArray(
                                    data.err_paid_options
                                )
                                    ? data.err_paid_options
                                    : [];
                            }
                            if (response.data.err_key === "cannot_send_msg") {
                                this.showSnackBar(response.data.err_msg);
                            }

                            throw response.data.err_msg;
                        }
                        this.showSnackBar(
                            this.$t("messages.something_went_wrong")
                        );
                        throw response.data.err_msg;
                    });
            } catch (error) {
                throw error;
            }
        },
        closeTipMenu() {
            this.isShowTip = false;
        },
        openTipMenu() {
            this.isShowTip = true;
        },
        async sendMessageTipMethod(data) {
            const message = (data.text || "").trim();
            if (!message) {
                this.messageModel = "";
                return;
            }
            data.message = data.text;
            if (this.isBroadcastingChannel && !this.isChatOwner) {
                await this.sendTipMessageToBroadcast({
                    chat_id: this.$route.params.chat_id,
                    message,
                    ...data,
                })
                .then((res) => {
                    this.setMessages(res.data);
                    this.messageModel = "";
                    if (!this.chatChannel) {
                        this.setChatChannel();
                    }

                    const broadcastTipMessageInfo = {
                        message_type: 'Tip',
                        channel: 'Broadcast',
                        ownBroadcast: false,
                    };
                    this.$mixpanel.click('Send Tip', 'Chat Screen', {
                        message_info: broadcastTipMessageInfo
                    });
                })
                .catch((e) => {
                    if (e.response.data.err_key === INSUFFICIENT_FUNDS_ERROR) {
                        this.insufficientFundsError = true;
                    }
                });
            } else {
                await this.sendTipMessage({
                    user_id: this.interlocutorId,
                    message,
                    ...data,
                })
                .then((res) => {
                    this.setMessages(res.data);
                    this.messageModel = "";
                    if (!this.chatChannel) {
                        this.setChatChannel();
                    }

                    const chatTipMessageInfo = {
                        message_type: 'Tip',
                        channel: 'Direct Message',
                        to: this.companion.name
                    };
                    this.$mixpanel.click('Send Tip', 'Chat Screen', {
                        message_info: chatTipMessageInfo
                    });
                })
                .catch((e) => {
                    if (e.response.data.err_key === INSUFFICIENT_FUNDS_ERROR) {
                        this.insufficientFundsError = true;
                    }
                });
            }
            this.messageModel = "";
        },
        handleCloseInsufficientFundsError() {
            this.insufficientFundsError = false;
        },
        handleTypingMessage() {
            if (this.chatChannel) {
                this.chatChannel.whisper("TypingMessageEvent", {
                    typing: true,
                });
            }
        },
        handleScrolled() {
            this.readMessages({
                chat_id: this.chatId,
            });
            this.scrollToLastMessage = false;
        },
        scrolledToPin() {
            this.scrollToPinnedMessage = false;
        },
        setMessages(data) {
            this.messages.push(data);
            this.toLastMessage();
        },
        handleShowTypingMessage() {
            this.isTyping = true;
            clearTimeout(this.typingTimer);
            this.typingTimer = setTimeout(() => {
                this.isTyping = false;
            }, 2000);
        },
        handleIncomingMessage(message) {
            if (
                this.isBroadcastingChannel ||
                message.user_id !== this.$auth.user().id
            ) {
                this.setMessages(message);
            }
        },
        async handleSubscribe() {
            this.showDirectMessageDialog = false;
            await this.subscribe({ id: this.interlocutorId }).then((res) => {
                if (typeof res.redirectUrl !== "undefined") {
                    this.$window.location = res.redirectUrl;
                }
                if (typeof res.success !== "undefined") {
                    this.$store.commit("showSnackBar", res.success);
                }
            });
            await this.setOtherUser(this.interlocutorId);
        },
        handleCloseDirectMessageDialog() {
            this.showDirectMessageDialog = false;
        },
        handleCloseResult() {
            this.setStep(0);
        },
        async handleDirectMessage() {
            await this.buyDirectMessage(this.interlocutorId)
                .then((res) => {
                    if (typeof res.redirectUrl !== "undefined") {
                        this.$window.location = res.redirectUrl;
                    }
                    if (typeof res.success !== "undefined") {
                        this.$store.commit("showSnackBar", res.success);
                    }
                })
                .catch(({ response }) => {
                    if (response.status === 400) {
                        if (
                            response.data.err_key === INSUFFICIENT_FUNDS_ERROR
                        ) {
                            this.insufficientFundsError = true;
                            this.showDirectMessageDialog = false;
                            return;
                        }
                    }
                    this.showSnackBar(this.$t("messages.something_went_wrong"));
                });
            await this.setOtherUser(this.interlocutorId);
            this.handleCloseDirectMessageDialog();
        },
        async handleClickPhoto() {
            try {
                // Add photo story feature to broadcast
                if (this.isBroadcastingChannel && this.isChatOwner) {
                    const fromChat = {
                        companion: this.companion,
                        chatId: this.chatId,
                    };
                    this.setStepFromChat({ step: 0, fromChat: fromChat });
                    return;
                }

                await this.checkPermissionToSendMessages();

                const fromChat = {
                    companion: this.companion,
                    chatId: this.chatId,
                };
                this.setStepFromChat({ step: 0, fromChat: fromChat });
            } catch (error) {
                console.log(error);
            }
        },
        handleIncomingStory() {
            this.setChatChannel();
            this.$nextTick(() => {
                this.scrollToLastMessage = true;
            });
        },
        handleReloadChat() {
            this.setChatChannel();
            this.toLastMessage();
        },
        async setChatChannel() {
            return await new Promise(async (resolve) => {
                let {
                    chat_id,
                    interlocutor_id,
                    messages,
                    storyExist,
                    userImg,
                    isBroadcastingChannel,
                    isChatOwner,
                    pinned_message = null,
                    opening,
                    ownOpening
                } = await this.setChat(
                    this.$route.params.chat_id
                        ? { chat_id: this.$route.params.chat_id }
                        : {
                              user_id:
                                  this.companionId || this.$route.params.id,
                          }
                );
                if (!chat_id) {
                    await this.$router.push({ name: "user.own.messages" });
                    return;
                }
                this.messages = messages;
                this.chatId = chat_id;
                this.interlocutorId = interlocutor_id;
                this.storyExist = storyExist;
                this.userImg = userImg;
                this.isBroadcastingChannel = isBroadcastingChannel;
                this.isChatOwner = isChatOwner;
                this.pinnedMessage = pinned_message;
                this.opening = opening;
                this.ownOpening = ownOpening;

                // Make event listener to work for all broadcast, DMs and broadcast channel owners
                
                if (this.chatId) {
                    this.$echo.connector.connect();
                    this.chatChannel = this.$echo.private(
                        `App.Models.Chat.${this.chatId}`
                    );
                    this.chatChannel
                        .listenForWhisper("TypingMessageEvent", () => {
                            this.handleShowTypingMessage();
                        })
                        .listen("IncomingMessageEvent", (response) => {
                            // This console is for test purpose(If listener works on staging or not)
                            if (typeof response.message !== "undefined" && response.message.user_id !== this.$store.state.user.user.data.id) {
                                if (response.message.story_id) {
                                    this.handleIncomingStory();
                                } else {
                                    this.handleIncomingMessage(
                                        response.message
                                    );
                                }
                            }
                            this.toLastMessage();
                        });
                }
                this.toLastMessage();
                resolve();
            });
        },
        toLastMessage() {
            this.$nextTick(() => {
                this.scrollToLastMessage = true;
            });
        },

        async startRecordingAudio() {
            this.isAudioRecording = true;
            this.$core.storyCore.startRecordingAudio();
        },

        async stopRecordingAudio() {
            this.isAudioRecording = false;
            const audioBlob = await this.$core.storyCore.stopRecordingAudio();
            if (this.isBroadcastingChannel && this.isChatOwner) {
                let chatId = this.$route.params.chat_id;
                await this.uploadAudioMessageToBroadcast({ audioBlob, chatId: chatId })
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        this.setMessages(res.data);
                        this.messageModel = "";
    
                        if (!this.chatChannel) {
                            this.setChatChannel();
                        }
                        this.toLastMessage();

                        const broadcastAudioMessageInfo = {
                            message_type: 'Audio',
                            channel: 'Broadcast',
                            ownBroadcast: true,
                        };
                        this.$mixpanel.click('Send Audio', 'Chat Screen', {
                            message_info: broadcastAudioMessageInfo
                        });
                    }
                });
            } else {
                await this.checkPermissionToSendMessages();
                await this.uploadAudioMessage({ audioBlob, receiverId: this.interlocutorId })
                .then((res) => {
                    if (typeof res.data !== "undefined") {
                        this.setMessages(res.data);
                        this.messageModel = "";
    
                        if (!this.chatChannel) {
                            this.setChatChannel();
                        }
                        this.toLastMessage();

                        const chatAudioMessageInfo = {
                            message_type: 'Audio',
                            channel: 'Direct Message',
                            to: this.companion.name
                        };
                        this.$mixpanel.click('Send Audio', 'Chat Screen', {
                            message_info: chatAudioMessageInfo
                        });
                    }
                });
            }
        },

        async cancelRecordingAudio() {
            this.isAudioRecording = false;
            this.isRecordingDeleted = true;
            await this.$core.storyCore.cancelRecordingAudio()
            .then(() => {
                setTimeout(() => {
                    this.isRecordingDeleted = false;
                }, 1000);
            });
        },

        async MessagePinned(message_id) {
            await this.pinMessage({
                message_id: message_id,
                chat_id: this.chatId,
            })
            .then(() => {
                this.pinnedMessage = this.messages.find(msg => msg.id === message_id);
            });
        },

        async messageUnpinned(){
            await this.removePinMessage({
                chat_id: this.chatId,
            })
            .then(() => {
                this.pinnedMessage = null;
            });
        },

        handleBack() {
            if (!!this.companionId) {
                this.$emit('back');
                return;
            }

            if (this.isBroadcastingChannel) {
                this.$router.push({ name: 'user.own.channels' });
            } else {
                this.$router.push({ name: 'user.own.messages' });
            }
        },

        handleScroll() {
            const container = this.$refs.chatLayout;
            if (container) {
                this.hasScrolled = container.scrollTop > 0;
            } else {
				this.hasScrolled = window.scrollY > 0;
			}
        },

        async handlePrizeGiven() {
            try {
                const response = await this.priceGiven({
                    box_open_id: this.opening.id,
                    user_id: this.interlocutorId,
                });

                if (response.success) {
                    this.opening.prize_status = "prize_given";
                    this.showSnackBar("Prize Given Confirmed!");
                }
            } catch (error) {
                console.error("Error marking prize as given:", error);
            }
        },

        boxReceviedDialog() {
            try {
                if(this.ownOpening.prize_given_at && !this.ownOpening.is_prize_confirmed) {
                    this.showReceivedPrizeDialog = true;
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },

        async confirmPriceGiven() {
            try {
                const response = await this.priceGiven({
                    box_open_id: this.ownOpening.id,
                    user_id: this.currentUser.id,
                    type: 'confirm'
                });

                if (response.success) {
                    this.showReceivedPrizeDialog = false;
                    this.ownOpening = response.data;
                    this.showSnackBar("Price confirm successfully!");
                }

            }  catch (error) {
                this.showSnackBar("Something went wrong");
                console.error("Error:", error);
            }
        },

        priceNotGiven() {
            // this.showReceivedPrizeDialog = false;
            this.showPopup = true;
        },

        async reportPrizeNotGiven(message)
        {
            try {
                const res = await this.sendContact({
                    question: message,
                    type: 'mystery_box',
                    box_open_id: this.ownOpening.id,
                })
            } catch (error) {
                this.showSnackBar("Something went wrong");
            }
        },

        ...mapActions([
            "setChat",
            "setOtherUser",
            "sendMessage",
            "sendTipMessage",
            "sendTipMessageToBroadcast",
            "subscribe",
            "buyDirectMessage",
            "readMessages",
            "uploadAudioMessage",
            "uploadAudioMessageToBroadcast",
            "pinMessage",
            "removePinMessage",
            "priceGiven",
            "sendContact"
        ]),
        ...mapMutations(["setStepFromChat"]),
    },
    computed: {
        subscribePrice() {
            return this.companion.subscribePrice;
        },
        directPrice() {
            return this.companion.directMessagePrice;
        },
        ...mapState({
            // profileImage: state => state.otherUser.user.profileImage,
            user: (state) => state.otherUser.user,
            verified: (state) => state.otherUser.user.verified,
            step: (state) => state.story.isShowCameraScreen.step,
            currentUser: (state) => state.user.user.data,
        }),
        canSendMessages() {
            return this.user.canSendMessages;
        },
        pinnedMessageDisplay() {
            if (!this.pinnedMessage) {
                return "";
            }

            if (this.pinnedMessage.type == TYPE_STORY) {
                return this.$t("messages.type_story");
            } else if(this.pinnedMessage.type == TYPE_AUDIO) {
                return this.$t("messages.type_audio");
            }

            return this.pinnedMessage.message && this.pinnedMessage.message.length > 10
                ? this.pinnedMessage.message.substring(0, 10) + '...'
                : this.pinnedMessage.message;
        },
        showPrizeSent() {
            return this.opening && this.opening.prize_requested_at && !this.opening.prize_given_at && this.opening.prize_status != 'prize_given';
        }
    },
    async mounted() {
        this.$mixpanel.identifyUser(this.currentUser.email);
        await this.setChatChannel();

        this.setOtherUser(this.interlocutorId).then((companion) => {
            if (
                !!companion.err_key &&
                companion.err_key === ERROR_KEYS.NOT_FOUND
            ) {
                this.$router.push({ name: "404" });
            } else {
                this.companion = companion;
            }
            this.$mixpanel.track('chat_opened', {
                chat_with_user: this.companion.email,
            });
        });

        this.$nextTick(() => {
             this.scrollToLastMessage = true;
        });

        // this.boxReceviedDialog();
		const container = this.$refs.chatLayout;
		if (container) {
			this.$refs.chatLayout.addEventListener('scroll', this.handleScroll, { passive: true });
		} else {
			window.addEventListener('scroll', this.handleScroll, { passive: true });
		}
    },
    beforeDestroy() {
		const container = this.$refs.chatLayout;
		if (container) { 
			this.$refs.chatLayout.removeEventListener('scroll', this.handleScroll);
		} else {
			window.removeEventListener('scroll', this.handleScroll);
		}
    },
};
</script>

<style scoped lang="scss">
@import "@/sass/modules/_variables";

.bottom-control {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    height: 74px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    background: black;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        border: none;
        background: transparent;
        min-width: 40px;
        height: 40px;
        padding: 10px;
    }
}

.show-pinned-chat-message { width: 100%; position: fixed; top: 0px; left: 0px; display: flex; flex-direction: column; background-color: #313131; border-radius: 0px; padding: 5px 10px; z-index: 99999; }
.show-pinned-chat-message span:nth-child(1) { font-size: 14px; font-weight: 600; }
.show-pinned-chat-message span:nth-child(2) { font-size: 12px; }
.show-pinned-chat-message button { position: absolute; top:50%; right: 15px; transform: translateY(-50%); }

.top-text {
    font-size: 1.7em;
    font-weight: 900;
}

.back-icon {
    font-size: 1.1em;
    left: 0;
}

.chat-layout {
    background: black;
    width: 100%;
    height: calc(100vh - 74px);    
}

.messages-section {
    padding-bottom: 150px; /* 74px for input bar */
}

.top-section {
    position: sticky;
    width: 100%;
    background: #000;
    z-index: 1;
    top: 0;
    left: 0;
    padding-top: 30px;
}

.top-section.scrolled { padding-left: 40px !important }
.top-section.scrolled .back-icon .v-icon { top: 7px; left: -44px; }
.top-section.scrolled .heading-style { justify-content: flex-start !important; }
.top-section.scrolled .user-info { display: flex; align-items: center; justify-content: flex-start }
</style>
